import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "最新动画", to: "/category/最新" },
  { label: "热门推荐", to: "/category/热门" },
  { label: "动漫资讯", to: "/news" },
  { label: "搜索作品", to: "/search" },
];

const categoryLinks = [
  { label: "奇幻冒险", to: "/category/热门" },
  { label: "科幻机甲", to: "/category/最新" },
  { label: "治愈日常", to: "/category/推荐" },
  { label: "青春校园", to: "/category/推荐" },
  { label: "悬疑推理", to: "/category/热门" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-200/70 bg-secondary-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-14 xl:px-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="flex flex-col gap-3">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
                <i className="ri-movie-2-fill" />
              </span>
              <span className="font-heading text-xl font-extrabold text-foreground-950">
                <span className="text-primary-600">58</span>动漫
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-foreground-600">
              58动漫致力于为动漫爱好者提供丰富的动画作品展示及最新动漫资讯，涵盖热门动漫推荐、作品介绍与行业动态。
            </p>
            <div className="flex items-center gap-2 pt-1">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-fill", "ri-tiktok-fill"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50 text-base text-foreground-600"
                >
                  <i className={icon} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-bold text-foreground-900">快速导航</h3>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-bold text-foreground-900">热门分类</h3>
            <ul className="flex flex-col gap-2.5">
              {categoryLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-bold text-foreground-900">关于本站</h3>
            <ul className="flex flex-col gap-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-primary-500" />
                contact@58dongman.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-base text-primary-500" />
                每日 09:00 - 22:00 更新资讯
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-information-line mt-0.5 text-base text-primary-500" />
                <span>本站为动漫资讯演示站点，内容均为示范数据。</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 58动漫 · 最新动漫资讯与动画作品展示平台
          </p>
          <p className="text-xs text-foreground-500">
            本站内容均为演示数据，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}